import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { SlPencil } from "react-icons/sl";

type Props = {
  to: string;
  disabled?: boolean;
};

const EditLinkAction = ({ to, disabled }: Props) => {
  return (
    <Tooltip title={disabled ? "" : "تعديل"}>
      <span>
        <IconButton
          component={Link}
          to={to}
          size="medium"
          color="primary"
          disabled={disabled}
        >
          <SlPencil />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default EditLinkAction;
